import { Link } from '@mui/joy';
import { t } from 'i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Value } from 'core/types';
import { QuoteEntityType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

export const getLinkValue = (value: Value, url?: string) => {
  if (!url) {
    return value;
  }

  return (
    <Link component={RouterLink} to={url} target="_blank" fontSize={14} fontWeight={600}>
      {value}
    </Link>
  );
};

// The flags come from /quote/details only and gate order submission, so plain quotes skip them.
export const getInactiveBillToProjectLinkMessage = (
  quote: Pick<ICustomerQuote, 'inactiveBillToProjectLink'> | undefined,
  entityType: QuoteEntityType
): string | undefined =>
  QuoteEntityType.ORDER === entityType && quote?.inactiveBillToProjectLink
    ? t('messageInactiveBillToProjectLink')
    : undefined;

export const getInactiveShipToProjectLinkMessage = (
  quote: Pick<ICustomerQuote, 'inactiveShipToProjectLink'> | undefined,
  entityType: QuoteEntityType
): string | undefined =>
  QuoteEntityType.ORDER === entityType && quote?.inactiveShipToProjectLink
    ? t('messageInactiveShipToProjectLink')
    : undefined;
